import MenuLanding from 'views/profile/landing';
import PublicProfile from 'views/profile/publicProfile';
import ConversationsNearby from 'views/conversationsNearby/index';
import ChatScreen from 'views/chatScreen';
import ChatRoomPage from 'views/chatRoom';
import NewsPage from 'views/news';
import NewsDetailPage from 'views/news/newsDetail/NewsDetailPage';
import BroadCast from 'views/BroadCast/index';
import Jitsi from '../components/Jitsi/Jitsi';
import Help from 'views/help/Help';
import RoomRedirect from 'views/chatScreen/RoomRedirect';
import ChatRoomRedirect from 'views/chatRoom/ChatRoomRedirect';
import { featureFlags } from 'config/featureFlags';

/** One App-level route so MenuLanding stays mounted while switching settings tabs. */
const settingsPaths = [
  '/profile/edit',
  '/invite-friend',
  '/currency',
  '/date-and-time',
  ...(featureFlags.showNotificationsSettings ? ['/notifications'] : []),
  '/email-notifications',
  '/terms-and-conditions',
  '/privacy-policy',
  ...(featureFlags.showExplainerVideo ? ['/explainer-video'] : []),
  '/subscription',
  '/feedback',
];

export default [
  {
    path: settingsPaths,
    component: MenuLanding,
  },
  {
    path: '/help/browser-settings',
    component: Help,
  },
  {
    path: '/help/os-privacy-settings',
    component: Help,
  },
  {
    path: '/help/notification-settings',
    component: Help,
  },
  {
    path: '/help',
    component: Help,
  },
  {
    path: '/call/:encodedData',
    component: BroadCast,
  },
  {
    path: '/call',
    component: BroadCast,
  },
  {
    path: '/jitsi',
    component: Jitsi,
  },
  {
    path: '/profile',
    component: PublicProfile,
  },
  {
    path: '/dashboard/:roomId',
    component: RoomRedirect,
  },
  {
    path: '/dashboard',
    component: ChatScreen,
  },
  {
    path: '/news/:id',
    component: NewsDetailPage,
  },
  {
    path: '/news',
    component: NewsPage,
  },
  {
    path: '/chat-room/:roomId',
    component: ChatRoomRedirect,
  },
  {
    path: '/chat-room',
    component: ChatRoomPage,
  },
  {
    path: '/conversations-nearby',
    component: ConversationsNearby,
  },
];
